import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { RuleDefinitionFormComponent } from './ruledefinition-form/ruledefinition-form.component';
import { RuleDefinitionComponent } from './ruledefinition.component';
import { RuleDefinitionRoutes } from './ruledefinition.routing';

export function declaration() {
    return [RuleDefinitionComponent, RuleDefinitionFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class RuleDefinitionModule {
}

@NgModule({
    imports: [RuleDefinitionModule, RuleDefinitionRoutes],
    exports: [RuleDefinitionModule]
})
export class RuleDefinitionWithRouteModule {
}
